import {Component, HostBinding, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FusionAuthService} from '../../shared/services/fusion-auth';
import {ScreenService} from '../../shared/services/general';
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {Keepalive} from "@ng-idle/keepalive";
import {environment} from "../../../environments/environment";
import {LogOut} from "../../stores/actions/fusion-auth.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../stores/app.state";

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit {
  public idleState = 'Not started.';
  private timedOut = false;
  private lastPing?: Date;


  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes)
      // @ts-ignore
      .filter(cl => this.screen.sizes[cl])
      .join(' ');
  }

  constructor(private router: Router, public screen: ScreenService,
              private idle: Idle,
              private store: Store<AppState>,
              private keepalive: Keepalive) {

    idle.setIdle(environment.production ? 15 * 60 : 5 * 60);
    idle.setTimeout(environment.production ? 60 : 60);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;

      if (this.router.url !== '/login') {
        localStorage.setItem('logoutRoute', this.router.url);
      }
      this.store.dispatch(new LogOut());
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'You will be logged out in ' + countdown + ' seconds!'
    });

    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.reset();
  }

  public get IsAlmostTimedOut (): boolean {
    return !this.idleState.startsWith('Started');
  }

  private reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  public async ngOnInit(): Promise<void> {
    if (localStorage.getItem('logoutRoute')) {
      const url = localStorage.getItem('logoutRoute');
      localStorage.removeItem('logoutRoute');
      await this.router.navigateByUrl(url as string);
    }
  }

  public get IsDesktop() {
    return this.screen.isDesktop();
  }
}
